import _remove from "lodash/remove";
import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import { FetchStatus } from "../../../globalConsts";
import { TemplateNotification } from "../../../globalTypes";
import {
  errorReceiveAllNotifications,
  errorRequestTemplateNotifications,
  receiveAllNotfications,
  receiveResolveNotification,
  receiveResolveNotifications,
  receiveTemplateNotifications,
  requestFetchAllNotifications,
  requestTemplateNotifications,
  resetNotificationsSlice,
  resolveNotifications,
} from "../actionCreators";

const { Uninitialized, FetchingInitial, Refetching, Fetched, Failed } =
  FetchStatus;

export type State = {
  messages: TemplateNotification[];
  fetchStatus: FetchStatus;
};

const initialState: State = {
  messages: [],
  fetchStatus: Uninitialized,
};

const templateNotificationsReducer = reducer(
  initialState,
  on(
    ...union(requestTemplateNotifications, requestFetchAllNotifications),
    (state) => {
      const isFirstFetch = state.fetchStatus === Uninitialized;
      state.fetchStatus = isFirstFetch ? FetchingInitial : Refetching;
    }
  ),
  on(receiveAllNotfications, (state, { payload: { notifications } }) => {
    state.messages = notifications.templateNotifications;
    state.fetchStatus = Fetched;
  }),
  on(receiveTemplateNotifications, (state, { payload: { notifications } }) => {
    state.messages = [...notifications];
    state.fetchStatus = Fetched;
  }),
  on(
    ...union(errorRequestTemplateNotifications, errorReceiveAllNotifications),
    (state) => {
      state.fetchStatus = Failed;
    }
  ),
  on(resolveNotifications, (state, { payload: { notificationIds } }) => {
    notificationIds.forEach((notificationId) =>
      _remove(state.messages, (msg) => msg.notificationId === notificationId)
    );
  }),
  on(
    receiveResolveNotification,
    (state, { payload: { notificationId }, error }) => {
      if (error) return;
      _remove(state.messages, (msg) => msg.notificationId === notificationId);
    }
  ),
  on(
    receiveResolveNotifications,
    (state, { payload: { notificationIds }, error }) => {
      if (error) return;

      _remove(
        state.messages, // I <3 PRETTIER
        (msg) => notificationIds.includes(msg.notificationId)
      );
    }
  ),
  on(resetNotificationsSlice, () => initialState)
);

export default templateNotificationsReducer;
